import { SHEET_VARIANTS, Sheet, SheetContent } from '@/components/Sheet';

import MenuContent from './MenuContent';

function SidebarMobile({ open, onChange }) {
	return (
		<Sheet open={open} onOpenChange={value => onChange(value)}>
			<SheetContent appear={SHEET_VARIANTS.FADE} hasCross>
				<MenuContent closeMenu={() => onChange(false)} />
			</SheetContent>
		</Sheet>
	);
}

export default SidebarMobile;
